let config = {
    scrollDelay: 100,
    scrollTime: 300
};

export default class Tab {
    constructor(element, options) {
        this.$element = $(element);
        this.$navItems = this.$element.find('[role="tab"],[data-tab-trigger]');
        this.$tabPanels = this.$element.find('[role="tabpanel"]');
        this.emptyPanelCls = 'tab__panel--empty';
        this.isScrollable = !!this.$element.data('tab-scrollable');

        config = $.extend(config, options);
    }

    show(e) {
        let clicked = $(e.currentTarget);
        const targetTabName = clicked.attr('aria-controls');
        const target = targetTabName ? $(`[aria-controls="${targetTabName}"]`) : clicked;

        let toShow = $('#' + target.attr('aria-controls'));

        if (toShow.length === 0) {
            return false;
        }

        this.$navItems.removeClass('is--selected')
            .attr('aria-selected', false);

        target.addClass('is--selected')
            .attr('aria-selected', true);

        this.$tabPanels.removeClass('is--active')
            .attr('aria-hidden', true);

        toShow.addClass('is--active')
            .attr('aria-hidden', false);
    }

    scrollToNav(event) {
        let $tab = $(event.currentTarget);

        setTimeout(() => {
            $('html, body').animate({
                scrollTop: $tab.offset().top
            }, config.scrollTime);
        }, config.scrollDelay);
    }

    setListeners() {
        this.$navItems
            .undelegate('click', this.show.bind(this))
            .on('click', this.show.bind(this));

        if (this.isScrollable) {
            this.$navItems
                .on('click', $.proxy(this, 'scrollToNav'));
        }
    }

    initPanels() {
        this.$tabPanels.each((k, panel) => {
            if ($(panel).children().filter(':not(.tab__panel__item--empty)').length === 0) {
                $(panel).addClass(this.emptyPanelCls);
            }
        });
    }

    init() {
        this.setListeners();
        this.initPanels();
    }
}
